import cowboy from "../assets/img/sad-cowboy.png";

export function NoDataAvailable({ pluralNoun }: { pluralNoun?: string }) {
  return (
    <div className="flex h-full flex-col items-center justify-center">
      <p className="text-center normal-case text-gray-300 dark:text-gray-500">
        No {pluralNoun || "data"} available
      </p>

      <img className="h-4" src={cowboy} alt="Sad cowboy" />
    </div>
  );
}
